import type {
  Block,
  ListData,
} from "../../../../models/ManualAuthoring";
import RefLink from "../editor/RefLink";

import "./bulletList.css";

export default function BulletListView({ block }: { block: Block }) {
  const data = block.data as ListData;

  return (
    <div className="pdf-block pdf-bullet-list">
      {(data.items || []).map((item, index) => (
        <div key={index} className="pdf-bullet-list__row">
          <span className="pdf-bullet-list__bullet">•</span>

          <span className="pdf-bullet-list__text">
            {(item.textParts || []).map((part, i) => {
              if (part.type === "text") {
                return <span key={i}>{part.value}</span>;
              }

              return (
                <RefLink
                  key={i}
                  targetId={part.targetId}
                  label={part.label}
                  className="pdf-ref-link text-primary"
                />
              );
            })}
          </span>
        </div>
      ))}
    </div>
  );
}
